import { render } from "./Replay.vue?vue&type=template&id=06c8a574"
import script from "./Replay.vue?vue&type=script&lang=js"
export * from "./Replay.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__